export default __webpack_public_path__ + "static/media/headerEvent-min.a4617bae.jpg";